import { Button, Form, Modal, Select, Input } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect, useState } from 'react';
import { createEleveInscriptions } from './eleve.reducer';
import { getEcoleAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
import { getClasses } from '../classe/classe.reducer';
import { StatutInscription } from 'app/shared/model/inscription.model';
import { useHasAnyAuthority } from 'app/hooks/useHasAnyAuthority';
import { AUTHORITIES } from 'app/config/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusAnneeScolaire } from 'app/shared/model/anneeScolaire.model';

const InscriptionModal: React.FC<{ ecoleId: string; eleveId: string }> = ({ ecoleId, eleveId }) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const anneeScolaireList = useAppSelector(state => state.anneeScolaire.entities);
  const classList = useAppSelector(state => state.classe.entities);
  const loading = useAppSelector(state => state.eleve.loading);
  const inscriptions = useAppSelector(state => state.eleve.entitiesInscriptions);
  const hasPermission = useHasAnyAuthority([AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR]);

  useEffect(() => {
    dispatch(getEcoleAnneeScolaire(ecoleId));
    dispatch(getClasses(ecoleId));
  }, [dispatch, ecoleId]);

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const saveEntity = async (values: any) => {
    const { anneeScolaireId, classeId } = values;
    await dispatch(
      createEleveInscriptions({
        anneeScolaireId,
        classeId,
        ecoleId,
        eleveId,
        statutInscription: StatutInscription.EN_ATTENTE,
        montantInscription: values.montantInscription,
      })
    );
    setOpen(false);
  };

  return (
    <>
      {hasPermission && (
        <Button
          onClick={showModal}
          className="btn jh-create-entity"
          id="jh-create-entity"
          style={{
            backgroundColor: '#F28E19',
            color: 'white',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            margin: '.4rem 0',
            justifySelf: 'flex-end',
          }}
          data-cy="entityCreateButton"
        >
          <FontAwesomeIcon icon="plus" />
          &nbsp; Nouvelle Inscription
        </Button>
      )}

      <Modal title="Créer une nouvelle inscription" visible={open} confirmLoading={loading} onCancel={handleCancel} footer={null}>
        <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} onFinish={saveEntity} layout="horizontal" size="large">
          <Form.Item
            label="Année Scolaire"
            name="anneeScolaireId"
            rules={[{ required: true, message: "L'année scolaire est obligatoire" }]}
          >
            <Select placeholder="Liste des années scolaires" style={{ width: '100%' }} optionFilterProp="children" allowClear showSearch>
              {anneeScolaireList
                .filter(as => as.statutAnneeScolaire !== StatusAnneeScolaire.CLOTUREE)
                .map(anneeScolaire => (
                  <Select.Option
                    key={anneeScolaire.id}
                    value={anneeScolaire.id}
                    disabled={inscriptions?.some(inscription => inscription.anneeScolaireId === anneeScolaire.id) || false}
                  >
                    {anneeScolaire.nom}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item label="Classe" name="classeId" rules={[{ required: true, message: 'La classe est obligatoire' }]}>
            <Select placeholder="Liste des classes" style={{ width: '100%' }} optionFilterProp="children" showSearch allowClear>
              {classList.map(classe => (
                <Select.Option key={classe.id} value={classe.id}>
                  {classe.nom}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="montantInscription"
            label="Montant d'inscription"
            rules={[{ required: true, message: "Le montant d'inscription est obligatoire" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 14, offset: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button onClick={handleCancel}>Annuler</Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                Enregistrer
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default InscriptionModal;
